export const text = {
  nav: 'Garden Config',
  title: 'Garden Configuration',
  description: 'Configure seed sowing settings for plants in your garden',
  selectGarden: 'Select Garden',
  selectGardenPrompt: 'Select a garden above to configure sowing settings',
  noGardens: 'No gardens found. Create a garden first to configure sowing.',
  noPlants: 'No plants in this garden yet. Add plants first.',
  sowingDescription:
    'Set when each plant should be sown in this garden, plus seed buffer and active status.',
  plant: 'Plant',
  sowMonth: 'Sow Month',
  sowWeek: 'Sow Week',
  sowWeekPlaceholder: 'Week',
  sowMonthPlaceholder: 'Month',
  noPlantsInGarden: 'No plants in this garden',
  seedBuffer: 'Seed Buffer',
  active: 'Active',
  applyToSelected: 'Apply to Selected',
  clearSelection: 'Clear Selection',
  bulkActionsTitle: (count: number) => `Bulk Actions (${count} selected)`,
};
